import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivationStart, NavigationEnd, Router } from '@angular/router';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { TeamFoldersController } from '@commoncore/controller/TeamFoldersController';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { TEAM_FOLDER_ROUTES } from '@commoncore/enums/ROUTES';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { IndexDBImplementation } from '@commoncore/implementation/IndexDBImplementation';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { AlbumsController } from '@mainrepo/app/core/controller/AlbumsController';
import { AudiosController } from '@mainrepo/app/core/controller/AudiosController';
import { DocumentsController } from '@mainrepo/app/core/controller/DocumentsController';
import { FavoritesController } from '@mainrepo/app/core/controller/FavoritesController';
import { PeoplesTabController } from '@mainrepo/app/core/controller/PeoplesTabController';
import { PhotosController } from '@mainrepo/app/core/controller/PhotosController';
import { RecentFilesController } from '@mainrepo/app/core/controller/RecentFilesController';
import { SearchController } from '@mainrepo/app/core/controller/SearchController';
import { SharedFilesListController } from '@mainrepo/app/core/controller/SharedFilesListController';
import { VideosController } from '@mainrepo/app/core/controller/VideosController';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { ShareAudiosController } from '@sharerepo/app/core/controller/ShareAudiosController';
import { ShareDocumentsController } from '@sharerepo/app/core/controller/ShareDocumentsController';
import { SharePhotosController } from '@sharerepo/app/core/controller/SharePhotosController';
import { ShareVideosController } from '@sharerepo/app/core/controller/ShareVideosController';
import { UnivShareLinkAllFilesController } from '@sharerepo/app/core/controller/UnivShareLinkAllFilesController';
import { AllFilesController } from 'projects/mainrepo/src/app/core/controller/AllFilesController';
import { IndexedDBModule } from 'projects/mainrepo/src/app/core/database/IndexedDBManager';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../core/services/global.service';
import { ActiveRepo } from '../../../core/services/universal.service';
declare var jQuery: any;
declare var clevertap: any;
@Component({
  standalone:true,
  selector: 'lib-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss'],
  imports:[DependenciesModule]
})
export class TopMenuComponent implements OnInit, OnDestroy {
  @Output() setFavorite = new EventEmitter();
  @Output() unSetFavorite = new EventEmitter();
  @Output() restoreItems = new EventEmitter();
  @Output() deleteParmanently = new EventEmitter();
  @Output() uploadClicked = new EventEmitter();
  @Output() createFolder = new EventEmitter();
  @Output() createAlbum = new EventEmitter();
  @Output() setShare = new EventEmitter();
  @Output() closePreview = new EventEmitter();
  @Output() fullscreen = new EventEmitter();


  public addToCloud:boolean = false;
  public controller:any= null;
  public implRef:any;

  public photoController:any= null;
  public videoController:any= null;
  public audioController:any= null;
  public docController:any= null;

  public sub:Subscription;
  // public subDeselect:Subscription;
  // public check:number = this.universalService.selectedNodes.length;
  public universalService:any;
  public listService:any;
  public folderService:any;
  public fileOpsService:any;
  contextMenuService: any;
  loggerService: any
  shareLink: any;
  shareAccessService:any;
  shareController: any;
  showShareSortingOptions:boolean = false;
  cleverTapEventsService:any;
  albumsController:any;
  peopleTabController:any;
  static topMenu:any;
  showSortMenu:boolean = false;
  sortType:any="";
  db: IndexedDBModule;
  localStorageService:any;
  containerHeightCalc:any;
  recalculateHeightService:any;
  userDetails: any;
  contextMenuOpsService:any;
  tmfldController: any;
  moreOptions:any = [];
  openMoreOptions: boolean=false;
  contextMenuMobileService: any;
  cacheImpl: any;
  sessionStorageService:any;

  dynamicHeightForTopMenu: boolean;
  
  @HostListener('window:resize', [])resize(){
    this.calculateUIHeight();
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    let target = $(event.target).closest('.team-header-options');
    if(target[0] == undefined){
      this.openMoreOptions = false;
    }
  }

  constructor(private changeDetectorRef: ChangeDetectorRef,
    public globalService:GlobalService,
    public router:Router) { 
    this.setEnvObjects();
  }


  setEnvObjects(){
    this.universalService = this.globalService.getUniversalServiceRef();
    this.listService = this.globalService.getListServiceRef();
    this.folderService = this.globalService.getFolderServiceRef();
    this.fileOpsService = this.globalService.getFileOperationServiceRef();
    this.contextMenuService = this.globalService.getContextMenuServiceRef();
    this.contextMenuMobileService = this.globalService.getContextMenuMobileServiceRef();
    this.router = this.globalService.getRouterRef();
    this.loggerService = this.globalService.getLoggerServiceRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.db = IndexedDBModule.getInstance(this.globalService);
    this.localStorageService = this.globalService.getLocalStorageSvcRef();
    this.containerHeightCalc = this.globalService.getContainerHeightCalculatorService();
    this.recalculateHeightService = this.containerHeightCalc;
    this.contextMenuOpsService = this.globalService.getContextMenuOperationsServiceRef();
    this.cacheImpl = IndexDBImplementation.getInstance(this.globalService);
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
  }

  ngOnInit(): void {
    TopMenuComponent.topMenu = this;
    this.subscribeToChangeInRoute();
    this.registerEvents()
    this.controller = this.getAllFilesControllerInstance();
    this.implRef = this.controller.allFilesImplementation
    this.photoController = this.getPhotosControllerInstance();
    this.videoController = this.getVideosControllerInstance();
    this.audioController = this.getAudiosControllerInstance();
    this.docController = this.getDocumentsControllerInstance();
    this.tmfldController = TeamFoldersController.getInstance(this.globalService);
    this.userDetails = this.localStorageService.getUserData(true);
    let sortingOrder = localStorage.getItem("sharePublicSort") 
    if(sortingOrder && sortingOrder.includes("%2B")){
      this.universalService.sortIcon = 'NeueUpTraffic';
    }else{
      this.universalService.sortIcon = 'NeueDownTraffic'  ;
    }  
    
    if(!this.universalService.showPreview && this.universalService.isMobileDevice){
      var self = this;
      AppEvents.globalObservable.subscribe(event => {
        if(event["topMoreOptionsClicked"] && this.universalService?.currentTab == "Person Details"){
          self.showPeopleSorting();
        }
      })
    }

  }

  setHanlder(){
    this.universalService = this.globalService.getUniversalServiceRef();
  }

  outsideClick(event) {
    if(jQuery(event.currentTarget).find('.modal-content').is(':visible')) {
      this.universalService.showMobOptionMenu = false;
      this.universalService.showMobFileInfoPanel = false;
      this.universalService.isMobileTopMoreOptionMenu = false;
      this.universalService.isMobileShareOptionClicked = false;
      this.universalService.moreOptionsOnMobileClicked = false;
      // this.universalService.selectedNodes = [];
      this.universalService.disableModalBackdrop();
    }
  }
  shareMoreOptions () {
    this.universalService.disableModalBackdrop();
    this.universalService.isMobileTopMoreOptionMenu = false;
    let jcNavigator: any;
    jcNavigator = window.navigator;

    if (jcNavigator && jcNavigator.share) {
      var shareData = {
        title: 'JioAICloud',
        text: "View the files shared with you on JioAICloud.",
        url: window.location.href
      }

      jcNavigator.share(shareData).then(function(response) {
        // this.loggerService.log("Your system support sharing files.");
        clevertap.event.push("User_Sharelink_Shared", {
          "MEDIUM":"Other_app",
        });
      }, function(error) {
        // this.loggerService.log("There is some error in configuration.");
      });
    } else {
      // this.loggerService.log("Your system doesn't support sharing files.");
    }
  };
  shareOnWhatsApp() {
    this.universalService.disableModalBackdrop();
    this.universalService.isMobileTopMoreOptionMenu = false;
    var text = 'JioAICloud';
    var url = window.location.href;
    var message = encodeURIComponent(text) + " - " + encodeURIComponent(url);
    var whatsapp_url = "https://wa.me/?text=" + message;
    window.location.href = whatsapp_url;  
    
    clevertap.event.push("User_Sharelink_Shared", {
      "MEDIUM":"Whats_app",
    });
  }

  ngOnDestroy() {
    if(this.sub != undefined) {
      this.sub.unsubscribe();
    }
    // if(this.subDeselect != undefined) {
    //   this.subDeselect.unsubscribe();
    // }
    
    this.addToCloud = null;
    this.controller = null;
    this.implRef = null;
    this.universalService = null;
    this.listService = null;
    this.folderService = null;
  }


  openDesktopFileInfo() { 
    var self = this.universalService;   
    // this.getCleverTapData();
    // var cleverTapSource = this.source;
    self.disableModalBackdrop();
    self.showModalBackdrop();
    self.showMobFileInfoPanel = false;
    self.showFileInfo = true;
    this.contextMenuService.hideCustomContextMenu();
    // if(this.selectedFile['format'] == "Folder"){
    //   clevertap.event.push("User_FolderInfo_View", {
    //     "SOURCE":cleverTapSource
    //   });
    // }else{
    //   clevertap.event.push("User_FileInfo_View", {
    //     "ERROR":"SUCCESS",
    //     "SOURCE":cleverTapSource
    //   });
    // }
  }

  selectAllMobile(){
    var self=this.universalService;
    self.disableModalBackdrop();
    self.selectedNodes = [];
    self.mobileSelectionModeOn =true;
     if((this.router.url.includes('/favorites/') && self.listView) || self.currentTab  == "audio" || self.currentTab  == "docs"){
      this.loggerService.log("inside select all for list view mobile")
      if(self.objectsPreviewArray.length != 0){
        $('.listItem').addClass('list_info');
        self.objectsPreviewArray.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
        // clevertap.event.push("User_Allfiles_Selected", {
        //   "SOURCE":"Audio",
        // });
      }
    }else if(self.currentTab  == "videos" || (this.router.url.includes('/favorites/') && !self.listView)){
      if(self.objectsPreviewArray.length != 0){
        this.loggerService.log("inside select all for videos grid view mobile")
          $('.gridItem').addClass('grid_info');
          self.objectsPreviewArray.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
      }
    }else if( (self.currentTab == 'allfiles' || self.currentTab == 'PrivateFolder' || self.currentTab == 'Album Details' || self.currentTab == "DigiLocker") && !this.universalService.fetchAllRecentFiles){

      if(self.mobileSelectedObj.length != 0){
        let addedFolderCount = 0;
        self.mobileSelectedObj.map(function (obj) {
          if (obj.objectType == 'FR') {

            if (self.openFolderContent) {
              if (self.listView) {
                $('.visible').addClass('list_info');
              } else {
                $('.visible').addClass('grid_info');
              }
              addedFolderCount++
              self.selectedNodes.push(obj)
            } else if (addedFolderCount < self.mobFolderShownCount) {
              if (self.listView) {
                $('.visible').addClass('list_info');
              } else {
                $('.visible').addClass('grid_info');
              }
              addedFolderCount++
              self.selectedNodes.push(obj)
            }else{
              if (self.listView) {
                $('.notvisible').removeClass('list_info');
              } else {
                $('.notvisible').removeClass('grid_info');
              }
            }
          } else if(obj.objectType != 'FR'){
            if(self.listView){
              $('.visible').addClass('list_info');
            } else{
              $('.visible').addClass('grid_info');
            }
            self.selectedNodes.push(obj)
          }
          
        })
        self.showTopMenu = true;
      }
    }
    else if(this.router.url.includes('trash') || this.universalService.selectedTab == 'teamfolders' || this.universalService.currentTab == 'Search Results' || self.currentTab == "JioPhoneCallAI"){
      if(self.mobileSelectedObj.length != 0){
        if(self.listView){
          this.loggerService.log("inside select all for all files list view mobile")
          $('.listItem').addClass('list_info');
        }else{
          this.loggerService.log("inside select all for all files grid view mobile")
          $('.gridItem').addClass('grid_info');
        }  
        self.mobileSelectedObj.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
        // clevertap.event.push("User_Allfiles_Selected", {
        //   "SOURCE":"Allfiles",
        // });
       // this.mobileSelectedObj = [];/* ticket 102260*/
      }
    }else if((self.currentTab == 'allfiles' && this.universalService.fetchAllRecentFiles) ){
      
      if(self.recentMobileSelectedObj.length != 0){
        if(self.listView){
          this.loggerService.log("inside select all for all files list view mobile")
          $('.listItem').addClass('list_info');
        }else{
          this.loggerService.log("inside select all for all files grid view mobile")
          $('.gridItem').addClass('grid_info');
        }  
        self.recentMobileSelectedObj.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
        // clevertap.event.push("User_Allfiles_Selected", {
        //   "SOURCE":"Allfiles",
        // });
       // this.mobileSelectedObj = [];/* ticket 102260*/
      }
    }else if(self.currentTab  == "photos" || self.currentTab == "Person Details" ){
      if(self.objectsPreviewArray.length != 0){
        $('.fileThumbnail').addClass('grid_info');
        this.loggerService.log("inside select all for photos grid view mobile")
        self.objectsPreviewArray.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
        // clevertap.event.push("User_Allfiles_Selected", {
        //   "SOURCE":"Photos",
        // });
      }
    }else if(self.currentTab == "Place Details" ){
      if(self.objectsPreviewArray.length != 0){
        $('.gridItem').addClass('grid_info');
        this.loggerService.log("inside select all for photos grid view mobile")
        self.objectsPreviewArray.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
        // clevertap.event.push("User_Allfiles_Selected", {
        //   "SOURCE":"Photos",
        // });
      }
    }else if(self.fetchAllRecentFiles){
      if(self.objectsPreviewArray.length != 0){
        if(self.recentFilesListView){
          this.loggerService.log("inside select all for recent files list view mobile")
          $('.listItem').addClass('list_info');
        }else{
          this.loggerService.log("inside select all for recent files grid view mobile")
          $('.gridItem').addClass('grid_info');
        }  
        self.objectsPreviewArray.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
      }
    }else if(self.currentTab == 'sharedFiles'){
      if(self.mobileSelectedObj.length != 0){
        self.mobileSelectedObj.map(function (obj) {
          if(self.listView){
            $('.visible').addClass('list_info');
            self.selectedNodes.push(obj)
          }else{
            console.log("grid view is not supported for shared tab in mobile");
          }
        })
        self.showTopMenu = true;
      }
    }else if(self.activeRepo == ActiveRepo.INVITE){
      if(self.mobileSelectedObj.length != 0){
        self.mobileSelectedObj.map(function (obj) {
          if(self.listView){
            $('.visible').addClass('list_info');
            self.selectedNodes.push(obj)
          }else{
            $('.gridItem').addClass('grid_info');
            console.log("grid view is not supported for shared tab in mobile");
          }
        })
        self.objectsPreviewArray.map(function(obj){
          self.selectedNodes.push(obj)
        })
        self.showTopMenu = true;
      }
    }
    this.loggerService.log("selected nodes from  select all are ",this.universalService.selectedNodes,this.universalService.objectsPreviewArray)
    self.isMobileTopMoreOptionMenu =false;
    self.isFolderPresent();
    this.contextMenuService.decideContextMenuItems();
    setTimeout(() => {
      this.recalculateHeightService.sendRecalculateEventToComponents(true);
    }, 10);
   
  }

  switchOnMobileSelectionMode(){
    
    var self = this.universalService
    self.isMobileTopMoreOptionMenu =false;
    self.mobileSelectionModeOn =true;
    
    self.selectedNodes = [];
    self.clearSelection();
    self.disableModalBackdrop();
    this.contextMenuService.decideContextMenuItems();
  }

  switchOffMobileSelectionMode(){
    var self = this.universalService
    self.mobileSelectionModeOn = false;
    
    self.selectedNodes = [];
    $('.listItem').removeClass('list_info');
    $('.gridItem').removeClass('grid_info');
    self.disableModalBackdrop();
  }

  getModalBottomValue() {
    if(this.universalService.downloadInProgress){
      let temp = document.getElementById("downloadComponent").getBoundingClientRect().height+'px';
      return {'bottom': temp}
    }
    else{
      return {'bottom':''}
    }
  }






  openView() {
    
    this.universalService= this.globalService.getUniversalServiceRef();
    this.listService = this.globalService.getListServiceRef();
    this.folderService = this.globalService.getFolderServiceRef();
    // this.loggerService.log("inside open view function")
    // this.globalService.getCleverTapData();
    // var cleverTapSource = this.globalService.source;
    //this.controller=Instance.createInstance(this.globalService,"AllFilesController");
    if(this.router.url.includes('/favorites/')){
      this.controller = FavoritesController.getInstance(this.globalService);
    }
    else if(this.universalService.fetchAllRecentFiles){
      this.controller = RecentFilesController.getInstance(this.globalService);
      this.implRef = this.controller.recentFilesImplementation

    }else if(this.router.url.includes('/teamfolders/')){
      this.controller = TeamFoldersController.getInstance(this.globalService);

    } else if(this.router.url.includes("/search")){
      this.controller = SearchController.getInstance(this.globalService);
    } else if(!this.universalService.fetchAllRecentFiles){
      this.controller = this.getAllFilesControllerInstance();
      this.implRef = this.controller.allFilesImplementation
      this.implRef.allFilespreviousLink = "";
      this.implRef.allFilesnextLink = "";
      this.universalService.allFilesnextLink = "";
    } 

    this.listService.headerCheckBoxChecked = false;
    this.listService.deselectedNodesArray = [];
    
    this.universalService.selectedNodes = []; 
    
    
    this.universalService.nameSort = true;
    this.universalService.uploadButtonClicked = false;
    this.universalService.isMobileShareOptionClicked = false;
    this.universalService.moreOptionsOnMobileClicked = false;
    this.universalService.loadGridView = false;
    
    var url = window.location.href;
    if (this.universalService.listView) {
      this.universalService.listView = false;
      this.universalService.shareViewType = this.universalService.shareViewTypeGridName;
    } else {
      this.universalService.listView = true;
      this.universalService.shareViewType = this.universalService.shareViewTypeListName;
    }
    if(this.universalService.activeRepo == "main"){
      this.listService.listViewSortOrder = localStorage.getItem("listViewSortOrder") == null?"&sort=%2DfileCreatedDate":localStorage.getItem("listViewSortOrder");
    } else {
      this.listService.listViewSortOrder = localStorage.getItem("listViewSortOrder") == null?"&sort=%2DcreatedDate":localStorage.getItem("listViewSortOrder");
    }
    this.universalService.toggleView();
    if(this.router.url.includes('/favorites/')){
      if(window.location.pathname == '/favorites/myfiles'){
        this.controller.getMyFilesFavorites('My Files');
      } else{
        this.controller.getMyAlbumsFavorites('Album Files');
      }
    }else if(this.universalService.fetchAllRecentFiles){
      this.controller.getAllRecentFiles();
    }
    else if(this.router.url.includes('/teamfolders/')){
      let currTmfldObjectKey = this.sessionStorageService.getNestedTeamFolderkey();
      this.controller.getCurrentTeamFolderContent(currTmfldObjectKey);
    }else if(this.router.url.includes('/search')){
      this.controller.setEnvObjects(this.globalService);
      this.controller.fetchSearchResults();
    } else if(!this.universalService.fetchAllRecentFiles){
      $(".highlight-recent-item").removeClass("highlight-recent-item");
      this.fetchAllFilesAndFolders();
    }
    
    this.universalService.selectedNodes = [];
    this.universalService.showTopMenu = false;
    this.universalService.hideTopMenuOptions();
    if (this.universalService.listView && this.folderService.breadCrumbsList.length > 1) {
      this.listService.openFolderContent = true;
    }
    setTimeout(() => {
      this.calculateUIHeight();
    }, 500);
  }


  calculateUIHeight(){
    if(!this.universalService.listView || this.universalService.isMobileDevice){ // this check is added to avoid registering multiple subscribers for height calculation, there is already a subscription happening from listview comp
      this.recalculateHeightService.sendRecalculateEventToComponents(true);
    }
  }
  fetchAllFilesAndFolders(){
    //this.cacheImpl.clearStores("ALL_FILES");
    //this.cacheImpl.clearStores("FOLDERS");
    this.controller.switchView();
  }


  downloadItems() {
    AppEvents.globalObservable.next({"downloadItems": true,"files":this.universalService.selectedNodes});
    if(!this.universalService.isMobileDevice){
      this.listService.deSelectAll();
    } else {
      this.universalService.showMobOptionMenu = false;
      this.universalService.isMobileTopMoreOptionMenu = false;
      this.universalService.isMobileShareOptionClicked = false;
      this.universalService.moreOptionsOnMobileClicked = false;
      if(this.universalService.mobileSelectionModeOn){
        
        this.universalService.selectedNodes = [];
      }else{
        this.contextMenuMobileService.decideContextMenuItemsForMobile();
      }
      this.universalService.disableModalBackdrop();
      AppEvents.memorySubscriptions.next({"decidetimer":true});
    } 
  }

  resetVariables(){
    if(this.universalService.listView){
      let ele = (document.querySelector('.heading-wrap')) as any
      // let eve = new Event('click');
      if(ele){
        ele.dispatchEvent('click')
      }
    }
  }

  fetchTeamFolderOperationOptionsBasedonRole(){
    this.openMoreOptions = !this.openMoreOptions;
    this.contextMenuService.checkIfShowLocationOption();
    this.contextMenuService.getContextMenuForTeamFolders(this.universalService.currentTeamFolder);
    this.moreOptions = this.universalService.contextMenuOptions;
  }

  async decideAction(action, event?) {
    this.openMoreOptions = false;
    if(!this.universalService.isMobileDevice){
      this.universalService.operationInProgress = true;
    }
    if(event){
      event.stopPropagation();
    }

    this.contextMenuService.hideCustomContextMenu(); 
    
    if(action != 'showMoreOptions' && action != 'openPreviewOptions'){
        this.universalService.openMoreOptions = false;
    }
   
    switch(action){
      case "openFolder":
        this.universalService.sortByDateArray = [];
        this.universalService.sortByNameArray = [];
        if(this.universalService.openFolderContent){
          AppEvents.globalObservable.next({'open':true,"object":this.universalService.selectedFile,"objectName":this.universalService.selectedFile["objectName"]})
        }else{
          this.universalService.openFolderContent = true;
        }
        break;
      case "downloadItems":
        this.downloadItems();

        break;
      case "openPreviewForFile":
        this.cleverTapEventsService.fileOpened(this.universalService.currentTab);
        this.universalService.openPreview(this.universalService.selectedFile);
        this.db.clearStore("RecentFilesMetadata");  // refresh recent files in all files to latest previewed file
        this.contextMenuService.decideContextMenuItems();
        break;
      case "showFileInfo":
        this.cleverTapEventsService.fileInfoClicked(this.universalService.currentTab);
        this.universalService.openMoreOptions = false
        if(!this.universalService.isMobileDevice){
          AppEvents.optionSelected.next({fileInfo: true});
          this.universalService.showObjectInfo(this.universalService.selectedFile);
        }else{
          //AppEvents.optionSelected.next({fileInfo: true}); // getting set from below method 
          this.universalService.openMobileFileInfo(this.universalService.selectedFile)
        }
        break;
      case "addToJioCloud":
        this.universalService.openMoreOptions = false;
        this.fileOpsService.addtoJioCloud();
        break;
      case "createShareLink":
        AppEvents.optionSelected.next({share: true});
        this.universalService.openMoreOptions = false;
        this.fileOpsService.createShareLink(); 
        break;
      case "createMemoryShareLink":
        this.setShare.emit();
        if(this.universalService.isMobileDevice){
          this.contextMenuService.decideContextMenuItems();
        }
        break;
      case "getShareLink":
        this.cleverTapEventsService.publicShareLinkClick(this.universalService.currentTab)
        if(this.universalService.showMobOptionMenu)
          this.universalService.showMobOptionMenu = false;
        if(this.universalService.userLoggedIn){
          this.enhancedShareLink()
         // this.cleverTapEventsService.onShareGetLinkClick();
        }else{
          this.universalService.openCreateShareLink = true;
        }
        break;
      case "shareWithPeople": 
        if(event && event.target) {
          if(event.target.title == 'Private share') {
            //this.cleverTapEventsService.onShareAddPeopleClick();
            this.cleverTapEventsService.privateShareClick(this.universalService.currentTab);
          } else if(event.target.title == 'Share') {
            this.cleverTapEventsService.OnShareOptionClick();
          }
        }
        
        if(this.universalService.selectedNodes.length > 1) { //Multi share option
          this.universalService.popUpToBeOpened = 'multiShareMessagePopUp';
        } else {
          this.universalService.showShareWithPeople = true;
          AppEvents.optionSelected.next({shareWithPeople: true});
        }
        break;
      case "MobileShareOption": // Mobile share option will show more option to Getlink and Manage share
          this.universalService.showMobOptionMenu = false;
          this.universalService.isMobileShareOptionClicked = true;
          this.universalService.openMobileTopMoreOptionMenu();
          this.universalService.openMoreOptions = false; // fix for hiding the option menu and showing the preview option when selection mode is on and open with option is selected
          this.universalService.showModalBackdrop();
          this.contextMenuService.decideContextMenuItems();
          break;
      case "addToAlbum":
        this.universalService.openMoreOptions = false;
        this.fileOpsService.addToAlbum();
        AppEvents.optionSelected.next({addtoalbum:true})
        break;
      case "addToAlbumConfirmation":
        this.universalService.openMoreOptions = false;
        this.fileOpsService.addToAlbum();
        AppEvents.memorySubscriptions.next({addtoAlbumConfirmation:true})
        break;
      case "renameObject":
        this.universalService.openMoreOptions = false;
        this.fileOpsService.renameObject();
        AppEvents.optionSelected.next({rename:true});
        break;
      case "deleteObject":
        this.universalService.openMoreOptions = false;
        this.fileOpsService.deleteItem();
        AppEvents.optionSelected.next({delete: true});  
        break;
      case "addFavorite":
        this.addFavorite();
        
        break;
      case "removeFavorite":
        this.removeFavorite();
        
        break;
      case 'showMoreOptions':
        // this.contextMenuService.hideCustomContextMenu();
        this.toggleMoreOptionsMenu();
        // event.stopPropagation();
        break;
      case 'OffSelectionMode':
        this.switchOffMobileSelectionMode();
        break;
      case "move":
        this.universalService.openMoreOptions = false;
        this.fileOpsService.moveToSelectedPath();
        AppEvents.optionSelected.next({movecopy: true});
        break;
      case "moveToPrivateFolder":
        this.cleverTapEventsService.moveToPf();
        this.universalService.openMoreOptions = false;
        this.fileOpsService.moveObjectToPrivateFolder();
        break;
      case "moveOutOfPF":
        this.cleverTapEventsService.moveOutOfPf();
        this.universalService.openMoreOptions = false;
        this.fileOpsService.moveOutOfPrivateFolder();
        break;
      case "copy":
        this.universalService.openMoreOptions = false;
        this.fileOpsService.copyInSelectedPath();
        AppEvents.optionSelected.next({movecopy: true});
        break;
      case "showLessOptions":
        this.universalService.openMoreOptions = false;
        this.universalService.showMobOptionMenu = false;
        if(!this.universalService.mobileSelectionModeOn && this.universalService.isMobileDevice && !this.universalService.showPreview && !this.router.url.includes("/memory")){
          
          this.universalService.selectedNodes = [];
        }
        this.universalService.disableModalBackdrop();
        this.contextMenuService.decideContextMenuItems();
        this.universalService.decideMemoryTimer();
        break;
      case "closeMenu":
        this.universalService.showShareSortingOptions = false;
        this.universalService.showMobOptionMenu = false;
        this.listService.deSelectAll(event);
        this.listService.applicationRef.tick();
        break;
      case "restore":
        if(this.universalService.selectedTab == "TeamsFolderOperations"){
          this.contextMenuOpsService.restoreTrashedObject(this.universalService.selectedNodes);
        }else{
          this.restoreItems.emit();
        }
        break;
      case "deleteForever":
        AppEvents.optionSelected.next({deleteforever: true});
        break;
      // case "inviteFriends":
      //   AppEvents.optionSelected.next({invite: true});
      //   break;
      case "albumInfo":
        this.universalService.openMoreOptions = false;
        if(!this.universalService.isMobileDevice){
          this.universalService.showAlbumInfo(this.universalService.selectedFile);
        }else{
          this.universalService.openMobileAlbumInfo(this.universalService.selectedFile)
        }
        break;
      case 'setAsCoverPic':
        this.albumsController = AlbumsController.getInstance(this.globalService);
        var selectedObject = this.universalService.selectedFile
        this.albumsController.setEnvObjects(this.globalService);
        this.albumsController.setAsCoverPic(selectedObject);
        break;
      case "addHashTag":
        this.universalService.showMoreOptions = false;
        AppEvents.optionSelected.next({addHashTag:true});
        break;
      case "copyLink":
        var sharUrl = this.universalService.selectedFile.shareURL;
        this.universalService.showMobOptionMenu = false;
        this.universalService.disableModalBackdrop();
        this.controller = SharedFilesListController.getInstance(this.globalService);
        this.controller.enhancedShareImplementation.copyShareLink(sharUrl);
        break;
      case "openManageLink":
        AppEvents.optionSelected.next({ showEnhancedShareLink: true });
        break;
      case "deleteSharedLink":
        var shareKey = this.universalService.selectedFile.shareKey;
        this.controller = SharedFilesListController.getInstance(this.globalService);
        this.universalService.showLoader = true;
        this.controller.deleteSharedLink(shareKey);
        break;
      case "removeResults":
        AppEvents.peopleTabEvent.next({ showRemoveOptionsPopUp: true });
        break;
      case "setAsCoverPhoto":
        this.peopleTabController = PeoplesTabController.getInstance(this.globalService);
        var selectedObject = this.universalService.selectedFile
        this.peopleTabController.setEnvObjects(this.globalService);
        this.peopleTabController.setAsCoverPhoto(selectedObject);
        break;
      case 'teamFolderInfo':
        this.universalService.disableModalBackdrop();
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["FOLDER_INFO"],data]);
        break;
      case 'teamFolderTrash':
        this.universalService.disableModalBackdrop();
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["TRASH"],data]);
        break;
      case 'teamsFolderMembers':
        this.universalService.disableModalBackdrop();
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["MEMBERS"],data]);
        break;
      case 'teamFolderSettings':
        this.universalService.disableModalBackdrop();
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["SETTINGS"],data]);
        break;
      case 'teamFolderactivitylog':
        this.universalService.disableModalBackdrop();
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["ACTIVITY_LOG"],data]);
        break;
      case 'teamFolderSharedItems':
        this.universalService.disableModalBackdrop();
        var data = this.getTeamFolderOperationsRoute();
        this.router.navigate([TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"]+TEAM_FOLDER_ROUTES["SHARED_ITEMS"],data]);
        break;
      case "teamsFolderLeave":
        this.contextMenuOpsService.leaveTeamFolder(this.universalService.currentTeamFolder);
        break;
      case "manageVersions":
        this.cleverTapEventsService.manageVerDownloadClicked();
        AppEvents.optionSelected.next({manageVersions: true});
        break;
      case 'openWithOfficeForWeb':
        var file = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
        var moduleType = this.fileOpsService.getModuleType(file);
        this.listService.deSelectAll(null);
        if(this.universalService.iframeLogin){
          var logincontroller = UserloginController.getInstance(this.globalService);
          var autoLoginUrl = await logincontroller.getAutoLogionToken();
          var token = autoLoginUrl["url"].split("?t=")[1];
          var msAuthUrl = "/a?t=" + token + "&msofficepreview=" + moduleType;
          window.open(msAuthUrl, "_blank", "noopener, noreferrer");
          return;
        }
        if(this.universalService.currentAlbum == undefined && (this.universalService.currentTab == 'Home' || this.router.url.includes('/filter/recents'))) {
          var fileOperController = FileOperationsController.getInstance(this.globalService);
          fileOperController.setEnvObjects(this.globalService);
          fileOperController.setAccessedDate(file);
          setTimeout(() => {
            AppEvents.emit(EventsList.UPDATE_RECENT);
          }, 500);
        }
        if(file["format"] == "SpreadSheet"){
          this.cleverTapEventsService.msOfficeClicked('Excel')
        }else if(file["format"] == "Document"){
          this.cleverTapEventsService.msOfficeClicked('Word')
        }else if(file["format"] == "Presentation"){
          this.cleverTapEventsService.msOfficeClicked('Powerpoint')
        }

        window.open(window.location.origin + '/document/editor/' + file["objectKey"] + "/" + moduleType , "_blank", "noopener, noreferrer");
        break;
      case 'openPreviewOptions':
        if(!this.universalService.isMobileDevice){
          if(this.universalService.openMoreOptionsContextMenu){
            this.universalService.removeHighlightFromSelectedOption();
            this.universalService.openMoreOptionsContextMenu = false;
            this.universalService.operationInProgress = false;
            this.contextMenuService.hideCustomMoreOptionsContextMenu();
          }else{
            this.universalService.operationInProgress = false;
            this.universalService.openMoreOptionsContextMenu = true;
            this.universalService.highlightSelectedOption(action);
          }
        }else{
          this.universalService.showMobOptionMenu = false;
          this.universalService.openMobileTopMoreOptionMenu();
          this.universalService.openMoreOptions = false; // fix for hiding the option menu and showing the preview option when selection mode is on and open with option is selected
          this.universalService.showModalBackdrop();
          this.contextMenuService.decideContextMenuItems();
          this.universalService.moreOptionsOnMobileClicked = true;
          this.contextMenuMobileService.decideMoreOptionsOnSubMenu(this.universalService.selectedFile,action);
        }
        break;
      case 'hidePhotoFromMemory':
        AppEvents.memorySubscriptions.next({hidePhotoConfirmation: true});
        this.contextMenuService.decideContextMenuItems();
        break;
      case 'removeMemory':
        AppEvents.memorySubscriptions.next({removeMemoryConfirmation: true});
        this.contextMenuService.decideContextMenuItems();
        break;
      case "showFileLocation":
      if(this.universalService.selectedFile){
        let parentObject = this.universalService.selectedFile.parentObjectKey;
        this.fileOpsService.resetRequiredDataBeforeOpeningTheLocationOfSelectedFile();
        this.listService.deSelectAll();
        this.localStorageService.removeLocalProperty(LocalStorageProps.SEARCH_KEY)
        if(this.universalService.searchType == 'teamfolder'){
          this.sessionStorageService.setCurrentTeamFolder({folderKey:this.universalService.currentTeamFolder["objectKey"],tfKey:this.universalService.currentTeamFolder["tfKey"]});
          this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootTeamFolderName, null);
          this.globalService.getFolderServiceRef().manageBreadCrumbs(this.universalService.currentTeamFolder["objectKey"], this.universalService.currentTeamFolder["tfName"],this.universalService.currentTeamFolder, null);
          this.router.navigate(['/teamfolders', parentObject], { queryParams: { tfKey: this.universalService.currentTeamFolder["tfKey"] } , queryParamsHandling: 'merge'});
        }else{
          this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootFolderNameNew, null);
          this.router.navigate(["/allfiles", parentObject], {state:{"initBreadCrumbs" : true}});
        }
      }
      break;
      case 'fullScreen':
        this.fullscreen.emit();
        break;
      case 'closePreview':
        this.closePreview.emit();
        break;
      case 'deleteAllcontacts':
        AppEvents.optionSelected.next({"deleteallcontacts":true});
        break;
      case "editPhoto":
        var file = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
        var moduleType = this.fileOpsService.getModuleType(file);
        moduleType = this.fileOpsService.setModuleDataForSavingTheEditedObject(file,moduleType,this.globalService.getFolderServiceRef().currentFolder)
        this.listService.deSelectAll(null);
        window.open(window.location.origin + '/jc-photo/editor/' + file["objectKey"] + "/" + moduleType, "_blank", "noopener, noreferrer");
        break;
      default:
        this.loggerService.log("item could not be found")
    }
  }

  getTeamFolderOperationsRoute(){
    if(!this.router.url.includes("/teamfolders/")) {
      this.universalService.currentTeamFolder = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
    }
    return this.universalService.currentTeamFolder["objectKey"] + "*" + this.universalService.currentTeamFolder["tfKey"];
  }

  toggleMoreOptionsMenu(){
    this.universalService.openMoreOptions = !this.universalService.openMoreOptions;
    if(this.universalService.openMoreOptions){
      this.universalService.pauseMemoryTimer();
    }else{
      this.universalService.decideMemoryTimer();
    }
    this.universalService.operationInProgress = false;
    this.universalService.openMoreOptionsContextMenu = false;
    // $(".highlight-recent-item").removeClass("highlight-recent-item");
    this.changeDetectorRef.detectChanges();
    if(this.universalService.isMobileDevice){
      // if(this.universalService.openMoreOptions){
      //   ($('#m-expanded-modal') as any).modal('show');
      // }else{
      //   if(this.universalService.selectedNodes.length>0){
      //     ($('#m-collapsed-modal') as any).modal('show');
      //   }
      // }
      this.contextMenuService.decideContextMenuItems();
    }
    if(!this.universalService.isMobileDevice || this.router.url.includes("/memory")) 
      return;
    if(this.universalService.openMoreOptions){
      this.universalService.showModalBackdrop();
    }else  if(this.universalService.isMobileDevice){
      this.universalService.disableModalBackdrop();
    }
  }

  closeMoreOptionsDropdown(){
    if(this.universalService.openMoreOptions == true){
      this.universalService.openMoreOptions = false;
    }
    
  }


  addFavorite(){
    this.universalService.pauseMemoryTimer();
    var object = this.fileOpsService.addFavorite();
    this.setFavorite.emit(object);
  }
  removeFavorite(){
    this.universalService.pauseMemoryTimer();
    var object = this.fileOpsService.removeFavorite();
    this.unSetFavorite.emit(object);
  }

  openPublicSort(sortType,reverseOrder:boolean = false){
    this.universalService.showShareSortingOptions = false;
    let CTSortParameter
    if(sortType == 'fileCreatedDate'){
      CTSortParameter = 'Created'
    }else if(sortType  == 'createdDate'){
      CTSortParameter ='Uploaded'
    }else if(sortType == 'objectName'){
      CTSortParameter ='Name'
    }
    let sortorder="";
    if(localStorage.previousSharePublicSort!=undefined && this.universalService.activeRepo == ActiveRepo.MAIN) {
      localStorage.removeItem("previousSharePublicSort");
    }
    if(this.universalService.activeRepo == ActiveRepo.SHARE && sortType == 'fileCreatedDate'){
      sortType = 'createdDate'; 
    }
    if(reverseOrder){
      sortorder = this.universalService.sharePublicSort.includes("%2B")?"Descending": "Ascending"
    }else{
      sortorder = this.universalService.sharePublicSort.includes("%2B")?"Ascending":"Descending"
    }
    if(this.universalService.currentTab == 'allfiles' || this.universalService.currentTab == 'PrivateFolder'){
      if(!(this.controller instanceof AllFilesController)){ 
        this.controller = this.getAllFilesControllerInstance();
        this.implRef = this.controller.allFilesImplementation
        this.controller.openPublicSort(sortType,reverseOrder);
      }else{
        const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
		    const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
        if(currentFolderKey == '' || rootFolderKey == currentFolderKey){
          this.cleverTapEventsService.sortInAllFiles(CTSortParameter,sortorder)
        }else if(currentFolderKey && (rootFolderKey != currentFolderKey)){
          this.cleverTapEventsService.sortInAllFilesFolder(CTSortParameter,sortorder)
        }
        this.controller.openPublicSort(sortType,reverseOrder);
      }
    }else if(this.universalService.currentTab == 'photos'){
      this.cleverTapEventsService.sortInPhotos(CTSortParameter,sortorder)
      this.photoController.openPublicSort(sortType,reverseOrder);
    }else if(this.universalService.currentTab == 'videos'){
      this.cleverTapEventsService.sortInVideos(CTSortParameter,sortorder)
      this.videoController.openPublicSort(sortType,reverseOrder);
    }else if(this.universalService.currentTab == 'audio'){
      this.cleverTapEventsService.sortInAudios(CTSortParameter,sortorder)
      this.audioController.openPublicSort(sortType,reverseOrder);
    }else if(this.universalService.currentTab == 'docs'){
      this.cleverTapEventsService.sortInDocs(CTSortParameter,sortorder)  
      this.docController.openPublicSort(sortType,reverseOrder);
    }else if(this.universalService.currentTab == 'teamfolders'){
      this.tmfldController.openPublicSort(sortType,reverseOrder);
    }
  }

  changeSort(){
    if(this.universalService.activeRepo == ActiveRepo.SHARE)
      return;
    if(this.universalService.sortIcon == 'NeueDownTraffic'){
      this.universalService.sortIcon = 'NeueUpTraffic';
    }else{
      this.universalService.sortIcon = 'NeueDownTraffic';
    }
    if (this.universalService.sharePublicSort.indexOf('objectName') > -1) {
      this.openPublicSort("objectName",true)
    }else if (this.universalService.sharePublicSort.indexOf('createdDate') > -1) {
      this.openPublicSort("createdDate",true)
    }else if (this.universalService.sharePublicSort.indexOf('fileCreatedDate') > -1) {
      this.openPublicSort("fileCreatedDate",true)
    }
     

  }

  showShareSortingDropDown(){
    this.universalService.showShareSortingOptions = !this.universalService.showShareSortingOptions
  }

  changeSortType(type){
    this.universalService.showLoader = true;
    if(this.shareAccessService.sortType == type){
      this.universalService.showShareSortingOptions = false;
      this.universalService.showLoader = false;
      return;
    }
    if(this.universalService.isUserOnSharedLinkByMe) {
      this.shareAccessService.sharedLinkSortType = type;
      this.shareAccessService.updateSort();
    } else {
      this.shareAccessService.sortType = type;
      this.shareAccessService.sort = type
      this.shareAccessService.updateSort();
      this.universalService.showShareSortingOptions = false;
      this.universalService.disableModalBackdrop();
      this.universalService.isMobileTopMoreOptionMenu = false;
    }
  }

  changeSharedLinkSortType(type) {

    if(this.listService.getSharedLinkByMeSortOrder() == null) {
      this.listService.sharedLinkByMeSortOrder = "&sort=%2DcreatedDate";
      
      if(this.universalService.isMobileDevice) {
        this.listService.sharedLinkByMeSortOrder = "&sort=%2BshareName";
      }
    } else {
      this.listService.sharedLinkByMeSortOrder = this.listService.getSharedLinkByMeSortOrder();
    }

    if(this.universalService.isMobileDevice) {
      if(type == 'cd') {
        this.listService.sharedLinkByMeSortOrder = "&sort=%2DcreatedDate";
        this.shareAccessService.sharedLinkSortType = "cd";
      } else {
        this.listService.sharedLinkByMeSortOrder = "&sort=%2BshareName";
        this.shareAccessService.sharedLinkSortType = "sname";
      }
    }

    this.listService.setSharedLinkByMeSortOrder(this.listService.sharedLinkByMeSortOrder);
    this.shareAccessService.updateSort();

  }

  shareWithPeopleOption() {
    this.cleverTapEventsService.onShareAddPeopleClick();
    if(this.universalService.selectedNodes.length > 1) { //Multi share option
      this.universalService.popUpToBeOpened = 'multiShareMessagePopUp';
    } else {
      this.universalService.showShareWithPeople = true;
      AppEvents.optionSelected.next({shareWithPeople: true});
    }
    this.universalService.isMobileShareOptionClicked = false;
    this.universalService.moreOptionsOnMobileClicked = false;
    this.universalService.isMobileTopMoreOptionMenu = false;
    this.universalService.showMobOptionMenu = false;
  }

  enhancedShareLink() {
    AppEvents.optionSelected.next({showEnhancedShareLink:true});   
  }

  uploadButtonClicked(){
    this.resetValuesAfterClickingOnUploadOrNewFolder();
    if(!this.router.url.includes('/albums')) {
      this.universalService.isAlbumsView = false;
    }
    AppEvents.emit(EventsList.UPLOAD_CLICKED);
    this.universalService.uploadButtonClicked = false;
    this.universalService.isMobileShareOptionClicked = false;
    this.universalService.moreOptionsOnMobileClicked = false;
    this.universalService.isUploadFromShare = false;
  }

  uploadFolderClicked(){
    this.resetValuesAfterClickingOnUploadOrNewFolder();
    if(!this.router.url.includes('/albums')) {
      this.universalService.isAlbumsView = false;
    }
    AppEvents.emit(EventsList.UPLOAD_FOLDER_CLICKED);
    this.universalService.uploadButtonClicked = false;
    this.universalService.isMobileShareOptionClicked = false;
    this.universalService.moreOptionsOnMobileClicked = false;
    this.universalService.isUploadFromShare = false;
  }

  newFolderClicked(){
    this.resetValuesAfterClickingOnUploadOrNewFolder();
      this.createFolder.emit();
      this.universalService.popUpToBeOpened = 'create Folder';
      AppEvents.globalObservable.next({createFolder:true});   
  }

  resetValuesAfterClickingOnUploadOrNewFolder(){
    this.universalService.disableModalBackdrop();
    this.universalService.uploadButtonClicked = false;
    this.universalService.isMobileShareOptionClicked = false;
    this.universalService.moreOptionsOnMobileClicked = false;
    this.universalService.isMobileTopMoreOptionMenu = false;
  }
  
  newAlbumClicked(){
    this.resetValuesAfterClickingOnUploadOrNewFolder();
    this.createAlbum.emit();
    this.universalService.popUpToBeOpened = 'create Album';
    AppEvents.globalObservable.next({createAlbum:true});   
  }

  registerEvents(){
    AppEvents.removeAllEventListener(EventsList.CHANGE_VIEW);
    AppEvents.removeAllEventListener(EventsList.DYNAMIC_TOP_MENU_HEIGHT);
    var classRef = this;
    AppEvents.on(EventsList.CHANGE_VIEW, ()=> {
      classRef.openView();
    })
    AppEvents.on(EventsList.DYNAMIC_TOP_MENU_HEIGHT, ()=> {
      classRef.addDynamicHeightForTopMenu();
    })
  }

  showPeopleSorting(){
    if(this.universalService.currentTab == "Person Details"){
      this.sortType =  this.localStorageService.getPeopleTabSortType();
    }
    this.universalService.showPeopleSortMenu = !this.universalService.showPeopleSortMenu;
  }
  showPlaceSorting(){
    if(this.universalService.currentTab == "Places"){
      this.sortType =  this.localStorageService.getPlaceTabSortType();
    }
    this.universalService.showPeopleSortMenu = !this.universalService.showPeopleSortMenu;
  }
  getSortedFaces(sortType,uiType){
    //uitype parameter is added for clevertap events
    this.cleverTapEventsService.userPeoplePageSorting(uiType);
    this.sortType = sortType;
    AppEvents.peopleTabEvent.next({"sortChange":sortType});
    this.universalService.showPeopleSortMenu = false;
  }
  getSortedPlaces(sortType,uiType){
    this.sortType = sortType;
    AppEvents.placeTabEvent.next({"sortChange":sortType});
    this.universalService.showPeopleSortMenu = false;
  }
  getAllFilesControllerInstance(){
    if(this.universalService.activeRepo == ActiveRepo.SHARE){
      return UnivShareLinkAllFilesController.getInstance(this.globalService);
    }else{
      return AllFilesController.getInstance(this.globalService);
    }
  }

  getPhotosControllerInstance(){
    if(this.universalService.activeRepo == ActiveRepo.SHARE){
      return SharePhotosController.getInstance(this.globalService);
    }else{
      return PhotosController.getInstance(this.globalService);
    }
  }

  getAudiosControllerInstance(){
    if(this.universalService.activeRepo == ActiveRepo.SHARE){
      return ShareAudiosController.getInstance(this.globalService);
    }else{
      return AudiosController.getInstance(this.globalService);
    }
  }

  getVideosControllerInstance(){
    if(this.universalService.activeRepo == ActiveRepo.SHARE){
      return ShareVideosController.getInstance(this.globalService);
    }else{
      return VideosController.getInstance(this.globalService);
    }
  }

  getDocumentsControllerInstance(){
    if(this.universalService.activeRepo == ActiveRepo.SHARE){
      return ShareDocumentsController.getInstance(this.globalService);
    }else{
      return DocumentsController.getInstance(this.globalService);
    }
  }

  getCurrentSortType(){
    return this.sessionStorageService.getSharePublicSortPropName();
  }

  subscribeToChangeInRoute(){
    let currentRouteData;
        this.router.events
          .subscribe(
            (event) => {
              if(event instanceof ActivationStart){
                currentRouteData = event.snapshot.data;
              }
              if (event instanceof NavigationEnd) {
                if(!currentRouteData["dynamicTopMenu"]){
                  this.removeDynamicHeightForTopMenu();
                }
              }
        });
  }

  addDynamicHeightForTopMenu(){
    this.dynamicHeightForTopMenu = true;
    $('.more-options-tab-inline-main').addClass('dynamicHeight');
    if(this.router.url.includes("/albums/")){
      $('.dynamicHeight').css({top:"155px"});
    }
  }

  removeDynamicHeightForTopMenu(){
    this.dynamicHeightForTopMenu = false;
    $('.more-options-tab-inline-main').removeClass('dynamicHeight');
    $('.more-options-tab-inline-main').removeAttr('style');
  }
}
